import React from "react";
import DeviceLimitModalView from "./DeviceLimitModalView";
import useDeviceLimitModalView from "../../hooks/useDeviceLimitModalView";

/**
 * 기기 등록 초과 안내 모달 (연결 전용)
 *
 * 채팅 전송 시 등록 가능한 기기 수를 초과하면 노출된다.
 * 해제할 기기를 고르면 교체(해제 + 등록)가 한 번에 처리되고,
 * 입력했던 메시지가 그대로 이어서 전송된다.
 *
 * 화면은 DeviceLimitModalView가 담당한다.
 */
const DeviceLimitModal: React.FC = () => {
  const {
    limitModalOpen,
    isSelectStep,
    activeDevices,
    selectedDeviceId,
    isProcessing,
    errorMessage,
    title,
    description,
    confirmText,
    cancelText,
    manageLinkText,
    confirmDisabled,
    handleConfirm,
    handleCancel,
    handleSelectDevice,
    handleMoveToDeviceManage,
    handleOpenChange,
  } = useDeviceLimitModalView();

  return (
    <DeviceLimitModalView
      open={limitModalOpen}
      onOpenChange={handleOpenChange}
      title={title}
      description={description}
      errorMessage={errorMessage}
      devices={isSelectStep ? activeDevices : undefined}
      selectedDeviceId={selectedDeviceId}
      onSelectDevice={isSelectStep ? handleSelectDevice : undefined}
      confirmText={confirmText}
      cancelText={cancelText}
      confirmDisabled={confirmDisabled}
      isProcessing={isProcessing}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      manageLinkText={isSelectStep ? manageLinkText : undefined}
      onMoveToDeviceManage={isSelectStep ? handleMoveToDeviceManage : undefined}
    />
  );
};

export default DeviceLimitModal;
